/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TaxAccountantWizardClientData = {
    avatar?: string;
    clientName?: string;
    color?: string;
    note?: string;
    taxableSupplyPeriod?: TaxAccountantWizardClientData.taxableSupplyPeriod;
    turnOnCorrection?: boolean;
};

export namespace TaxAccountantWizardClientData {

    export enum taxableSupplyPeriod {
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

